module.exports = __webpack_public_path__ + "img/detail-4.30852315.png";